import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobSiteChangeOrderActions'
import * as api from '../../api/job/jobSiteChangeOrders'

function* jobSiteChangeOrdersRefresh(action) {
  try {
    const payload = yield call(api.getJobSiteChangeOrders, action.jobId)
    yield put({ type: constants.JOB_SITE_CHANGE_ORDERS_REFRESH.SUCCESS, payload })
    action.next && action.next(payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_CHANGE_ORDERS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobSiteChangeOrders() {
  yield takeLatest(constants.JOB_SITE_CHANGE_ORDERS_REFRESH.ACTION, jobSiteChangeOrdersRefresh)
}

function* sagaCreateJobSiteChangeOrder(action) {
  try {
    const payload = {
      change_order_data: {
        job_id: action.jobId,
        estimate_id: action.estimateId,
        estimate_revision: 1,
        status: 'open',
        description: action.description,
        grand_total: action.grandTotal,
        selectedTemplate: action.selectedTemplate,
        scope_of_work: action.scopeOfWork,
        schedule: action.schedule,
        payment_schedule: action.payment_schedule
      },
      change_order_items: action.changeOrderItems
    }
    yield call(api.createJobSiteChangeOrder, payload)
    yield put({ type: constants.JOB_SITE_CHANGE_ORDER_CREATE.SUCCESS, payload })
    yield call(jobSiteChangeOrdersRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_CHANGE_ORDER_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobSiteChangeOrder() {
  yield takeLatest(constants.JOB_SITE_CHANGE_ORDER_CREATE.ACTION, sagaCreateJobSiteChangeOrder)
}

function* sagaUpdateJobSiteChangeOrder(action) {
  try {
    const payload = {
      change_order_data: {
        estimate_id: action.estimateId,
        estimate_revision: 1,
        status: action.status,
        job_id: action.jobId,
        description: action.description,
        number: action.number,
        grand_total: action.grandTotal,
        selectedTemplate: action.selectedTemplate,
        scope_of_work: action.scopeOfWork,
        schedule: action.schedule,
        payment_schedule: action.payment_schedule
      },
      change_order_items: action.changeOrderItems,
      change_order_id: action.changeOrderId
    }
    yield call(api.updateJobSiteChangeOrder, payload)
    yield put({ type: constants.JOB_SITE_CHANGE_ORDER_UPDATE.SUCCESS, payload })
    yield call(jobSiteChangeOrdersRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_CHANGE_ORDER_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobSiteChangeOrder() {
  yield takeLatest(constants.JOB_SITE_CHANGE_ORDER_UPDATE.ACTION, sagaUpdateJobSiteChangeOrder)
}

function* sagaDeleteJobSiteChangeOrder(action) {
  try {
    const payload = {
      attachment_id: action.attachmentId
    }
    yield call(api.deleteJobSiteChangeOrder, payload)
    yield put({ type: constants.JOB_SITE_CHANGE_ORDER_DELETE.SUCCESS, payload })
    yield call(jobSiteChangeOrdersRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_CHANGE_ORDER_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* getChangeOrderItems(action) {
  try {
    const payload = yield call(api.getChangeOrderItems, action.estimateId)
    yield put({ type: constants.GET_CHANGE_ORDER_ITEMS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_CHANGE_ORDER_ITEMS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetChangeOrderItems() {
  yield takeLatest(constants.GET_CHANGE_ORDER_ITEMS.ACTION, getChangeOrderItems)
}

function* watchDeleteJobSiteChangeOrder() {
  yield takeLatest(constants.JOB_SITE_CHANGE_ORDER_DELETE.ACTION, sagaDeleteJobSiteChangeOrder)
}

// ATTACHMENT SAGAS
function* uploadAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      changeOrderId: action.changeOrderId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_CHANGE_ORDER_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { changeOrderId: action.changeOrderId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_CHANGE_ORDER_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAttachments() {
  yield takeLatest(constants.UPLOAD_CHANGE_ORDER_ATTACHMENT.ACTION, uploadAttachments)
}

function* getAttachments(action) {
  try {
    const payload = yield call(api.getAttachments, action.changeOrderId)
    yield put({ type: constants.GET_CHANGE_ORDER_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_CHANGE_ORDER_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAttachments() {
  yield takeLatest(constants.GET_CHANGE_ORDER_ATTACHMENTS.ACTION, getAttachments)
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_CHANGE_ORDER_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getAttachments, { changeOrderId: action.changeOrderId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_CHANGE_ORDER_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_CHANGE_ORDER_ATTACHMENT_DESCRIPTION.ACTION,
    updateAttachmentDescription
  )
}

function* deleteAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      changeOrderId: action.changeOrderId
    }

    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.DELETE_CHANGE_ORDER_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { changeOrderId: action.changeOrderId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_CHANGE_ORDER_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAttachments() {
  yield takeLatest(constants.DELETE_CHANGE_ORDER_ATTACHMENT.ACTION, deleteAttachment)
}

function* fetchChangeOrderTemplates() {
  try {
    const payload = yield call(api.fetchChangeOrderTemplates)
    yield put({ type: constants.FETCH_CHANGE_ORDER_TEMPLATES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.FETCH_CHANGE_ORDER_TEMPLATES.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchChangeOrderTemplates() {
  yield takeLatest(constants.FETCH_CHANGE_ORDER_TEMPLATES.ACTION, fetchChangeOrderTemplates)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobSiteChangeOrders),

    fork(watchCreateJobSiteChangeOrder),
    fork(watchUpdateJobSiteChangeOrder),
    fork(watchDeleteJobSiteChangeOrder),

    fork(watchGetChangeOrderItems),

    fork(watchUploadAttachments),
    fork(watchGetAttachments),
    fork(watchUpdateAttachmentDescription),
    fork(watchDeleteAttachments),

    fork(watchFetchChangeOrderTemplates)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobSiteChangeOrderSaga.js